// Tooltip.tsx
import React from "react";
import { View, Text, StyleSheet } from "react-native";

type TooltipProps = {
  content: string;
  visible: boolean;
};

const Tooltip: React.FC<TooltipProps> = ({ content, visible }) => {
  if (!visible) return null;

  return (
    <View style={styles.tooltipContainer}>
      <View style={styles.tooltip}>
        <Text style={styles.tooltipText}>{content}</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  tooltipContainer: {
    position: "absolute",
    bottom: 30,
    right: 40,
    zIndex: 1000,
    alignItems: "center",
  },
  tooltip: {
    padding: 10,
    borderRadius: 5,
    backgroundColor: "black",
  },
  tooltipText: {
    color: "white",
  },
});

export default Tooltip;
